import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'

import { STRING } from 'resources'

import { OPEN_MODAL_KEYS } from '../constants'
import EmailRow from './EmailRow'
import {
  Container,
  TitleContainer,
  Title,
  ChevronRight,
  HorizontalLine,
  ButtonsContainer,
  AddEmailButton,
} from './styles'

const EmailAddressesSection = ({
  emailAddresses,
  setOpenModalKey,
  setEmailAddressData,
  selectedEmailAddress,
  setSelectedEmailAddress,
}) => {
  const [open, setOpen] = useState(false)
  const filteredEmailAddresses = useMemo(
    () => emailAddresses.filter((emailAddress) => open || emailAddress.isPrimary),
    [open, emailAddresses],
  )
  const showChevron = filteredEmailAddresses && emailAddresses.length > 0

  return (
    <Container>
      <TitleContainer>
        <Title>{STRING.protect.profileInfo.edit.emailAddresses.title}</Title>
        {showChevron && <ChevronRight $open={open} onClick={() => setOpen(!open)} />}
      </TitleContainer>
      <HorizontalLine />
      {filteredEmailAddresses.length > 0 ? (
        <>
          {filteredEmailAddresses.map((emailAddress) => (
            <EmailRow
              key={emailAddress.emailAddress}
              emailAddress={emailAddress}
              setOpenModalKey={setOpenModalKey}
              setEmailAddressData={setEmailAddressData}
              selectedEmailAddress={selectedEmailAddress}
              setSelectedEmailAddress={setSelectedEmailAddress}
            />
          ))}
          {open && (
            <ButtonsContainer>
              <AddEmailButton onPress={() => setOpenModalKey(OPEN_MODAL_KEYS.ADD_EMAIL_ADDRESS)}>
                {STRING.protect.profileInfo.edit.addEmailAddress}
              </AddEmailButton>
            </ButtonsContainer>
          )}
        </>
      ) : (
        <ButtonsContainer>
          <AddEmailButton onPress={() => setOpenModalKey(OPEN_MODAL_KEYS.ADD_EMAIL_ADDRESS)}>
            {STRING.protect.profileInfo.edit.addEmailAddress}
          </AddEmailButton>
        </ButtonsContainer>
      )}
    </Container>
  )
}

EmailAddressesSection.propTypes = {
  emailAddresses: PropTypes.arrayOf(
    PropTypes.shape({
      emailAddress: PropTypes.string.isRequired,
      isPrimary: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  setOpenModalKey: PropTypes.func.isRequired,
  setEmailAddressData: PropTypes.func.isRequired,
  selectedEmailAddress: PropTypes.string,
  setSelectedEmailAddress: PropTypes.func.isRequired,
}

export default EmailAddressesSection
